import React, { useState, useEffect } from "react";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { useFavoriteWheel } from "../../services/mutations";
import { colors } from "../../utils";
import { toast } from "react-toastify";
import { useQueryClient } from "react-query";

const FavoriteHeartIcon = ({
  wheelId,
  isFavorited,
  onFavoriteChange,
  size = "16px",
  filledColor = colors.error,
  unfilledColor = colors.black,
}) => {
  const [isLocalFavorited, setIsLocalFavorited] = useState(isFavorited);
  const queryClient = useQueryClient();

  const favoriteWheel = useFavoriteWheel();

  // Sync local state with prop changes (but only when not in the middle of a mutation)
  useEffect(() => {
    if (!favoriteWheel.isLoading) {
      setIsLocalFavorited(isFavorited);
    }
  }, [isFavorited, favoriteWheel.isLoading]);

  const handleFavoriteClick = (e) => {
    e.stopPropagation(); // Prevent event bubbling

    // Don't do optimistic update - wait for API response
    favoriteWheel.mutate(wheelId, {
      onSuccess: (response) => {
        const apiState = response?.data?.data?.is_favourite;

        // Update state only after API confirms the change
        setIsLocalFavorited(apiState);
        onFavoriteChange?.(apiState);

        // Delay cache invalidation to prevent flickering

        queryClient.invalidateQueries(["fetchExploreWheels"]);
        queryClient.invalidateQueries(["fetchWheels"]);
        queryClient.invalidateQueries(["wheel", wheelId]);

        toast.success(
          `Wheel ${apiState ? "favorited" : "unfavorited"} successfully`
        );
      },
      onError: (error) => {
        console.error("Favorite error:", error);
        toast.error("Failed to update favorite status");
      },
    });
  };

  return (
    <div
      onClick={handleFavoriteClick}
      style={{
        cursor: favoriteWheel.isLoading ? "wait" : "pointer",
        opacity: favoriteWheel.isLoading ? 0.6 : 1,
        transition: "opacity 0.2s",
      }}
    >
      {isLocalFavorited ? (
        <FavoriteIcon
          style={{
            fontSize: size,
            color: filledColor,
          }}
        />
      ) : (
        <FavoriteBorderIcon
          style={{
            fontSize: size,
            color: unfilledColor,
          }}
        />
      )}
    </div>
  );
};

export default FavoriteHeartIcon;
